import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { colors } from 'shared/assets/styles'
import { SmallText } from 'app/common/typography'
import { Collapsible } from 'app/common/collapsible'
import type { EventMetadata } from 'shared/store/metadata'
import { eventsDefinitions } from 'shared/store/metadata'
import type { FilterShortDTO } from 'shared/types'
import { AllergensWrapper } from './AllergensWrapper'
import { SPACING } from 'app-v2/design-tokens'

const { grey30, text } = colors

type Props = {
    noAllergens: boolean,
    allergens: Array<FilterShortDTO>,
    traces: Array<FilterShortDTO>,
    sendMeta: EventMetadata => void
}

type State = {
    isOpened: boolean
}

class Allergens extends Component<Props, State> {
    state = {
        isOpened: false
    }

    handleCollapseClick = (e: Event) => {
        e.preventDefault()
        const isOpened = !this.state.isOpened
        if (!isOpened) {
            const sendMeta = this.props.sendMeta
            const meta = eventsDefinitions.ALLERGEN
            sendMeta(meta)
        }
        this.setState({
            isOpened
        })
    }

    render() {
        const { noAllergens, allergens, traces } = this.props
        const { isOpened } = this.state
        return (
            <BottomBorder onClick={e => this.handleCollapseClick(e)}>
                <Collapsible
                    labelKey="product.allergens.title"
                    isOpened={isOpened}
                    color={text}>
                    <Fragment>
                        {noAllergens ? (
                            <FormattedMessage id="product.allergens.empty">
                                {(label: string) => (
                                    <NoAllergens color={text}>
                                        <SmallText>{label}</SmallText>
                                    </NoAllergens>
                                )}
                            </FormattedMessage>
                        ) : (
                            <Fragment>
                                <AllergensWrapper allergens={allergens} />
                                {traces.length > 0 && (
                                    <Fragment>
                                        <FormattedMessage id="product.allergens.traces">
                                            {(label: string) => (
                                                <TracesTitle color={text}>
                                                    {label}
                                                </TracesTitle>
                                            )}
                                        </FormattedMessage>
                                        <AllergensWrapper allergens={traces} />
                                    </Fragment>
                                )}
                            </Fragment>
                        )}
                    </Fragment>
                </Collapsible>
            </BottomBorder>
        )
    }
}

const NoAllergens = styled.div`
    padding: 15px 0;
`

const BottomBorder = styled.div`
    padding: ${SPACING.XS} 0;
    cursor: pointer;
`

const TracesTitle = styled(SmallText)`
    margin-top: 15px;
`

export { Allergens }
